<template>
  <div class="tw-flex tw-flex-col tw-pb-4 tw-px-4">
    <div
      class="tw-h-4 tw-bg-sf-snow-lighter tw-w-full tw-top-0 tw-sticky tw-z-50"
    />
    <RemarkGroup
      :name="I18n.t(`communication.inbox.talking_points_groups.${bucket}`)"
      :show-mark-as-read="false"
    >
      <TalkingPointsBucketContent :items="items" />
    </RemarkGroup>
  </div>
</template>

<script setup lang="ts">
import RemarkGroup from '@app/application/communication/screens/inbox/components/remark-group.vue'
import TalkingPointsBucketContent from '@app/application/communication/screens/inbox/components/talking-points-bucket-content.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { TalkingPointBucket } from '@app/application/communication/screens/inbox/store/utils'
import type { CheckLink, Remark } from '@app/application/communication/types'

const I18n = useI18n()

interface Props {
  bucket: TalkingPointBucket
  items: (Remark | CheckLink)[]
}
defineProps<Props>()
</script>

<style scoped>
.remark-group {
  --sf-remark-group-sticky-offset: 16px;
}
</style>
